export default __webpack_public_path__ + "static/media/new-registration.f1b0dd9c.png";